module.exports = __webpack_public_path__ + "img/productivity-apps.894c479f.webp";